import SearchFieldsCls from './SearchFieldsCls'

const SearchFieldsClsObj = new SearchFieldsCls()

export default SearchFieldsClsObj.GetSearchFields()
